import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import type { ContentLexicalStateV1 } from '@soundxyz/utils/lexical/ContentLexicalStateV1';
import { LexicalDisplayNodes } from '@components/Lexical/Display/Nodes';

export function LexicalDisplay({
  state,
  showMentionsHoverCard = true,
  className,
}: {
  state: ContentLexicalStateV1;
  showMentionsHoverCard?: boolean;
  className?: string;
}) {
  const [rootNode, setRootNode] = useState(state.root);

  useEffect(() => {
    setRootNode(state.root);
  }, [state]);

  return (
    <div className={twMerge('whitespace-pre-wrap', className)} data-feed-clickable-div>
      {rootNode && (
        <LexicalDisplayNodes
          showMentionsHoverCard={showMentionsHoverCard}
          depth={0}
          nodes={[rootNode]}
        />
      )}
    </div>
  );
}
